export default __webpack_public_path__ + "static/media/Hostinger_Nameserver.74fa43e7.webp";